
const searchBox = document.getElementById('search-form-input'),
	searchResultsWrapper = document.getElementById('search-form-results-wrapper'),
	searchResults = searchResultsWrapper.querySelector('.results'),
	searchResultsLoader = searchResultsWrapper.querySelector('.loader'),
	searchResultTemplate = document.getElementById('search-form-result-template');

export const typeAheadSearch = () => {
	searchBox.addEventListener('keyup', debounce(function() {
		if(searchBox.value.trim() == '') {
			searchResultsWrapper.classList.remove('show');
			searchResultsLoader.classList.remove('show');
			return;
		}
		searchResultsWrapper.classList.add('show');
		searchResultsLoader.classList.add('show');
		searchResults.innerHTML = '';
		fetch('/wp-json/tmu/v2/search?s=' + searchBox.value)
		.then(response => response.json())
		.then(function(data) {
			searchResultsLoader.classList.remove('show');

			data.forEach((item) => {
				const result = document.importNode(searchResultTemplate.content, true);
				result.querySelector('.title').innerHTML = item.title.rendered;
				result.querySelector('.title').href = item.link;
				result.querySelector('.excerpt').innerHTML = item.excerpt.rendered;
				searchResults.appendChild(result);
			});

		}).catch(function(error) {
			searchResultsLoader.classList.remove('show');
			searchResultsWrapper.classList.remove('show');
		});
	}, 500));
}

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};